import { useEffect, useState, useRef } from "react";
import ModalGlobal from "../modalGlobalTopbar/ModalGlobalTopbar";
import style from "./ModalMensagem.module.css";
import NotificacaoApi from "../../../services/NotificacaoApi";
import { Link } from "react-router-dom";
import { IoIosNotifications } from "react-icons/io";
import { LuListCheck } from "react-icons/lu";

function ModalMensagem({ mostrar, aoFechar, botaoRef }) {
  const [notificacoes, setNotificacoes] = useState([]);
  const [posicao, setPosicao] = useState({ top: 0, left: 0 });
  const [posicaoCalculada, setPosicaoCalculada] = useState(false);     
  const modalRef = useRef(null);

  // Cálculo de posição
  const calcularPosicao = () => {
    if (botaoRef?.current) {
      const rect = botaoRef.current.getBoundingClientRect();
      const left = Math.min(rect.right - 298, window.innerWidth - 310);
      const top = rect.bottom + 5;
      setPosicao({ top, left });
      setPosicaoCalculada(true); // Marca como calculada
    }
  };


  useEffect(() => {
    if (mostrar) {
      setPosicaoCalculada(false); // Reseta quando abrir
      setTimeout(() => {
        calcularPosicao();
      }, 0);

      window.addEventListener("resize", calcularPosicao);
    }

    return () => {
      window.removeEventListener("resize", calcularPosicao);
    };
  }, [mostrar]);

  // Buscar notificações
  useEffect(() => {
    async function fetchNotificacoes() {
      try {
        const notificacao = await NotificacaoApi.ListarNotificacoesPorUsuarioIdAsync();
        setNotificacoes(notificacao);
      } catch (error) {
        console.error("Erro ao listar notificações:", error?.response?.data);
      }
    }

    fetchNotificacoes();
  }, []);

  return (
    <ModalGlobal mostrar={mostrar} aoFechar={aoFechar} botaoRef={botaoRef}>
      {posicaoCalculada && (
        <div
          ref={modalRef}
          className={style.container_modal}
          style={{ top: `${posicao.top}px`, left: `${posicao.left}px` }}
        >
          <div className={style.header_notificacao}>
            <h5>Mensagens</h5>
            <Link
              className={style.icone_header}
              to="/notificacoes"
              title="Ver todas notificações"
            >
              <LuListCheck />
            </Link>
          </div>
          <div className={style.notificacao}>
            {notificacoes.map((notificacao) => (
              <Link
                to="/notificacoes"
                state={notificacao.notificacaoId}
                key={notificacao.notificacaoId}
                className={`${style.container_notificacao} ${!notificacao.lido ? style.notificacaoLida : ""}`}
              >
                <div className={style.conteudo_notificacao}>
                  <IoIosNotifications id={style.icone_notificacao} />
                  <h6 id={style.titulo_notificacao}>{notificacao.titulo}</h6>
                </div>
                <div className={style.corpo_notificacao}>
                  <p>{new Date(notificacao.dataEnvio).toLocaleString("pt-BR")}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </ModalGlobal>
  );
}

export default ModalMensagem;
